import React from 'react';
import { useTranslation } from 'react-i18next';
import Divider from '../../../components/misc/divider';
import { PriceUnderline } from '../../../components/svg/textDecorations';
import { useCurrency } from '../../../hooks/useCurrency';

const CheckoutTotal = ({
  subtotal,
  total,
  discount,
  tips,
  delivery,
  minimalRemaining,
  packaging,
  noDivider,
}) => {
  const { t } = useTranslation(['translation', 'delivery']);
  const { currencySymbol } = useCurrency();

  return (
    <div>
      {subtotal > 0 && (
        <div className="flex flex-row justify-between items-center">
          <p className="font-primaryMedium text-base text-primary">
            {t('translation:checkout.subtotal')}
          </p>
          <p className="font-primaryMedium text-base text-primary whitespace-nowrap">
            {subtotal.toFixed(2)} {currencySymbol}
          </p>
        </div>
      )}
      {/* !!discountCode && (
        <div className="flex flex-row justify-between items-center mt-2">
          <p className="font-primaryMedium text-base text-primary">
            {t('translation:checkout.discountCode')} ({discountCode})
          </p>
          <p className="font-primaryMedium text-base text-primary whitespace-nowrap">
            -{(discount || 0).toFixed(2)} {currencySymbol}
          </p>
        </div>
      ) */}
      {delivery > 0 && (
        <div className="flex flex-row justify-between items-center mt-2">
          <p className="font-primaryMedium text-base text-primary">
            {t('delivery:checkout.priceForDelivery')}
          </p>
          <p className="font-primaryMedium text-base text-primary whitespace-nowrap">
            {(delivery || 0).toFixed(2)} {currencySymbol}
          </p>
        </div>
      )}
      {minimalRemaining > 0 && (
        <div className="flex flex-row justify-between items-center mt-2">
          <p className="font-primaryMedium text-base text-primary">
            {t('delivery:checkout.priceToReachMin')}
          </p>
          <p className="font-primaryMedium text-base text-primary whitespace-nowrap">
            {(minimalRemaining || 0).toFixed(2)} {currencySymbol}
          </p>
        </div>
      )}
      {packaging > 0 && (
        <div className="flex flex-row justify-between items-center mt-2">
          <p className="font-primaryMedium text-base text-primary">
            {t('delivery:checkout.pricePackaging')}
          </p>
          <p className="font-primaryMedium text-base text-primary whitespace-nowrap">
            {(packaging || 0).toFixed(2)} {currencySymbol}
          </p>
        </div>
      )}
      {discount > 0 && (
        <div className="flex flex-row justify-between items-center mt-2">
          <p className="font-primaryMedium text-base text-primary">
            {t('translation:checkout.discount')}
          </p>
          <p className="font-primaryMedium text-base text-primary whitespace-nowrap">
            -{(discount || 0).toFixed(2)} {currencySymbol}
          </p>
        </div>
      )}
      {tips > 0 && (
        <div className="flex flex-row justify-between items-center mt-2">
          <p className="font-primaryMedium text-base text-primary">
            {t('translation:checkout.tip')}
          </p>
          <p className="font-primaryMedium text-base text-primary whitespace-nowrap">
            {(tips || 0).toFixed(2)} {currencySymbol}
          </p>
        </div>
      )}
      {(subtotal > 0 || discount > 0 || tips > 0) && <Divider className="mt-5 mb-5" />}
      <div className="flex flex-row justify-between items-center mt-2">
        <p className="font-primaryMedium text-2xl text-primary">
          {t('translation:checkout.total')}
        </p>
        <p className="font-primaryMedium text-2xl text-primary whitespace-nowrap">
          <span className="relative">
            {total.toFixed(2)} {currencySymbol}
            <PriceUnderline />
          </span>
        </p>
      </div>
      {!noDivider && <Divider className="mt-5 mb-4" />}
    </div>
  );
};

export default CheckoutTotal;
